import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { Router } from "@angular/router";
import { ComponentService } from "../../../services/component.service";
import { LocationStrategy } from "@angular/common";
import { SharedHttp } from "../../../services/http-client.service";
/**
 * Payment Instructions Wallet Modal Component
 */
let PaymentInstructionsWalletModalComponent = class PaymentInstructionsWalletModalComponent {
    constructor(sanitizer, router, httpClient, compService, location, domSanitizer, themeService) {
        this.sanitizer = sanitizer;
        this.router = router;
        this.httpClient = httpClient;
        this.compService = compService;
        this.location = location;
        this.domSanitizer = domSanitizer;
        this.themeService = themeService;
        this.secondColor = '';
        this.accentColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.errorColor = '';
        this.activeCurrency = 'rsd';
        this.loaded = false;
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
        this.ipsQRCode = this.data['ipsQRCode'] !== null ? this.domSanitizer.bypassSecurityTrustUrl('data:image/png;base64, ' + this.data['ipsQRCode']) : '';
    }
    ngOnDestroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }
    close() {
        this.modal.destroy();
    }
};
PaymentInstructionsWalletModalComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: Router },
    { type: SharedHttp },
    { type: ComponentService },
    { type: LocationStrategy },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
PaymentInstructionsWalletModalComponent = __decorate([
    Component({
        selector: 'ecd-payment-instructions-wallet-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./payment-instructions-wallet-modal.component.html")).default
    })
], PaymentInstructionsWalletModalComponent);
export { PaymentInstructionsWalletModalComponent };
